var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpresstransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_949)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.588,
    y: 155.107,
    width: 263.701,
    height: 183.492,
    rx: 31.0028,
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 10.9267
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.519 189.378H331.43L331.433 189.385C331.447 189.414 331.469 189.458 331.496 189.515C331.552 189.63 331.635 189.799 331.743 190.016C331.96 190.452 332.279 191.084 332.687 191.867C333.504 193.434 334.679 195.609 336.114 198.04C338.983 202.901 342.891 208.792 347.046 212.898C350.771 216.58 356.666 219.4 361.624 221.297C364.104 222.247 366.352 222.967 367.979 223.449C368.793 223.69 369.452 223.872 369.908 223.994C370.135 224.054 370.312 224.1 370.432 224.131C370.49 224.145 370.535 224.157 370.566 224.164V269.281C370.535 269.288 370.492 269.299 370.435 269.313C370.316 269.342 370.142 269.385 369.916 269.443C369.466 269.558 368.814 269.73 368.007 269.958C366.395 270.413 364.165 271.091 361.698 271.981C356.764 273.761 350.869 276.39 347.048 279.788C343.122 283.28 339.212 289.428 336.286 294.696C334.823 297.332 333.604 299.749 332.751 301.508C332.325 302.387 331.99 303.102 331.761 303.597C331.647 303.845 331.56 304.037 331.501 304.168C331.488 304.196 331.477 304.221 331.467 304.243C331.453 304.273 331.442 304.297 331.434 304.317L331.429 304.328H207.519V189.378Z",
    fill: "#4045A1",
    stroke: "black",
    strokeWidth: 0.131647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.535 124.724H275.962L201.929 344.063H89.2812L134.535 124.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.422 216.032H308.287V221.839H292.113C292.113 221.839 297.255 227.879 297.255 231.828H308.24V237.17H297.722C297.722 237.17 295.619 255.196 275.472 254.081L300.06 283.489H290.244L265.422 255.104V249.157C265.422 249.157 277.622 249.528 283.465 245.579C288.186 242.374 287.579 240.422 287.999 238.564C288.14 237.867 287.625 237.217 286.924 237.217H265.422V231.874H287.439C287.906 231.874 288.186 231.409 287.953 230.991C287.017 229.179 284.541 225.137 281.128 224.394C276.687 223.465 265.422 223.232 265.422 223.232V216.032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.461 193.018H223.289",
    stroke: "black",
    strokeWidth: 16.4559,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2266 246.999H158.054",
    stroke: "black",
    strokeWidth: 16.4559,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.219 295.385H173.753",
    stroke: "black",
    strokeWidth: 16.4559,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpresstransfer);
export default __webpack_public_path__ + "static/media/express transfer.d2ccb76f87a046dcaf8774ba726633c8.svg";
export { ForwardRef as ReactComponent };